import { Account, Page } from '../../../../types'
import { HttpClientConfig } from '../../../useHttpClientConfig'
import { baseUrl, service } from '../service'
import { applySearchParams, FilterValue, responseToPage, urlToPathnameAndSearch } from '../utils'

type AccountsFilter = 'id'
type AccountsFilters = Record<AccountsFilter, FilterValue>

const pathname = `/accounts`

const makeGetAccounts =
  (config: HttpClientConfig) =>
  async (filters: AccountsFilters): Promise<Page<Account>> => {
    const url = new URL(pathname, baseUrl)

    applySearchParams(url, filters)

    const pathnameAndSearch = urlToPathnameAndSearch(url)
    const response = await service.get(pathnameAndSearch, config)

    return responseToPage<Account>(response)
  }

export type { AccountsFilters }
export { makeGetAccounts }
